/* Fixed px styles for print/PDF (cqw breaks in print windows) */
export const MULKIYA_PRINT_CSS = `
@import url("https://fonts.googleapis.com/css2?family=Noto+Kufi+Arabic:wght@400;600;700&display=swap");

* { box-sizing: border-box; }
html, body {
  margin: 0;
  padding: 0;
  background: #fff !important;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  color: #1c1f2e;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
body {
  display: flex;
  justify-content: center;
  padding: 12px;
}
.ar {
  font-family: "Noto Kufi Arabic", Tahoma, sans-serif;
  direction: rtl;
}
.mk-doc {
  --ink: #2e2306;
  --rule: rgba(70, 50, 10, 0.55);
  --cell: rgba(255, 250, 225, 0.38);
  --muted: #6b7086;
  width: 100%;
  max-width: 560px;
  padding: 8px 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}
.mk-doc-title { text-align: center; }
.mk-doc-title .ar { font-size: 18px; font-weight: 700; color: #1c1f2e; }
.mk-doc-title .en { font-size: 18px; font-weight: 600; color: #1c1f2e; }

.mk-card {
  width: 560px;
  max-width: 100%;
  min-height: 353px;
  border-radius: 22px;
  position: relative;
  overflow: hidden;
  color: var(--ink);
  background:
    radial-gradient(120% 90% at 15% 10%, rgba(255,248,210,.55), transparent 55%),
    repeating-linear-gradient(115deg, rgba(255,255,255,.05) 0 2px, rgba(0,0,0,.025) 2px 4px),
    linear-gradient(135deg, #c79b3f 0%, #e6c977 28%, #d3ad57 52%, #efd88f 74%, #c39437 100%);
  box-shadow: 0 10px 28px rgba(80,55,10,.35), inset 0 0 0 1px rgba(255,255,255,.35);
  padding: 22px 24px 18px;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
  page-break-inside: avoid;
  break-inside: avoid;
}
.mk-card .wm {
  position: absolute;
  left: 50%;
  top: 52%;
  width: 200px;
  transform: translate(-50%, -50%);
  opacity: 0.1;
  pointer-events: none;
  filter: sepia(1) saturate(.6);
}
.mk-card > *:not(.wm) { position: relative; }

.c-head {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.c-head .en {
  font-family: "Times New Roman", Times, serif;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: .2px;
  line-height: 1.15;
}
.c-head .en small {
  display: block;
  font-weight: 400;
  font-size: 12px;
  color: #7a1414;
}
.c-head .ar {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
}
.c-head .ar small {
  display: block;
  font-weight: 600;
  font-size: 12px;
  color: #7a1414;
}
.c-head img {
  height: 52px;
  width: auto;
  display: block;
}

.c-sec {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0 0 8px;
}
.c-sec .en {
  font-family: "Times New Roman", Times, serif;
  font-size: 15px;
}
.c-sec .ar {
  font-size: 15px;
  font-weight: 600;
}

.c-tbl { border: 1px solid var(--rule); }
.r {
  display: grid;
  grid-template-columns: 19% 1fr 19%;
  border-bottom: 1px solid var(--rule);
  min-height: 26px;
}
.r:last-child { border-bottom: 0; }
.r.pair { grid-template-columns: 19% 1fr 17% 1fr 19%; }
.r > div {
  display: flex;
  align-items: center;
  padding: 3px 6px;
  min-width: 0;
}
.l {
  font-family: "Times New Roman", Times, serif;
  font-size: 11px;
  line-height: 1.1;
  border-right: 1px solid var(--rule);
}
.la {
  font-size: 11px;
  justify-content: flex-start;
  border-left: 1px solid var(--rule);
}
.v {
  background: var(--cell);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .2px;
  text-transform: uppercase;
  justify-content: center;
  text-align: center;
  gap: 8px;
  flex-wrap: wrap;
  word-break: break-word;
}
.v .ar { text-transform: none; font-weight: 700; }
.v.mono {
  font-family: ui-monospace, Menlo, Consolas, monospace;
  letter-spacing: .6px;
}
.m {
  flex-direction: column;
  align-items: stretch !important;
  justify-content: center;
  border-left: 1px solid var(--rule);
  border-right: 1px solid var(--rule);
  gap: 1px;
}
.m .ar { font-size: 9px; text-align: right; }
.m .en {
  font-family: "Times New Roman", Times, serif;
  font-size: 10px;
  text-align: left;
}

.c-foot {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
  margin-top: 10px;
}
.c-foot .note {
  font-size: 9px;
  font-weight: 600;
  line-height: 1.35;
}
.c-foot .brand {
  font-weight: 700;
  font-size: 13px;
  letter-spacing: .3px;
}
.c-foot .stamp {
  font-family: "Times New Roman", Times, serif;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 3px;
  opacity: .28;
  line-height: 1;
}

.status {
  display: inline-block;
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 99px;
  text-transform: none;
  letter-spacing: 0;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
.status.ok { background: #1f7a46; color: #fff; }
.status.warn { background: #a86512; color: #fff; }
.status.bad { background: #a32020; color: #fff; }
.status.na { background: rgba(0,0,0,.18); color: #fff; }

.mk-src {
  font-size: 11px;
  color: var(--muted);
  text-align: center;
}

@media print {
  @page { size: A4; margin: 10mm; }
  body { padding: 0; }
  .mk-card {
    box-shadow: none !important;
    width: 100%;
    max-width: 170mm;
  }
}
`;
